module.exports = __webpack_public_path__ + "img/homeBg.48c8446f.png";